import api from "@/services/api"
import { useQuery } from "@tanstack/vue-query"
import type { MaybeRef } from "@vueuse/core"
import { NEXT_NOTIFICATION_QUERY_KEY } from "@/services/queryKeys"

export type RetrieveNextNotificationResponse = {
  id: string
  contents: string
}

export type RetrieveNextNotificationQuery = {
  lastSeenId?: string | null
}

const listNotifications = async (
  query?: RetrieveNextNotificationQuery
) => {
  // Handling case where lastSeenId has not been retrieved from IPreferences yet
  if (query?.lastSeenId === undefined) return ""

  const { body: notification } = await api.get<
    RetrieveNextNotificationResponse | ""
  >("/notifications/next/", {
    query: query,
  })

  return notification
}

export const useNextNotification = (
  query: MaybeRef<RetrieveNextNotificationQuery>
) =>
  useQuery({
    queryKey: [NEXT_NOTIFICATION_QUERY_KEY, query] as const,
    queryFn: ({ queryKey: [_, query_] }) =>
      listNotifications(query_),
    staleTime: Infinity,
  })
